import {Actions} from '@redstack/shared'
import {createFileRoute} from '@tanstack/react-router'
import {OrgDetailPage} from '@/features/admin/OrgDetailPage'
import {adminOrgDetailQueryOptions} from '@/hooks/admin'
import {useRequirePermission} from '@/hooks/useRequirePermission'

function AdminOrgDetailGuard() {
	const {orgId} = Route.useParams()
	if (!useRequirePermission(Actions.ORGS_MANAGE)) return null
	return <OrgDetailPage orgId={orgId} />
}

export const Route = createFileRoute('/admin/$orgId')({
	component: AdminOrgDetailGuard,
	loader: ({context, params}) =>
		context.queryClient.ensureQueryData(
			adminOrgDetailQueryOptions(params.orgId),
		),
})
